import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=29dd9aa0"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports